import { Component } from '@angular/core';

@Component({
  selector: 'app-error-nostudyaccess',
  templateUrl: './error-nostudyaccess.component.html',
  styleUrls: ['./error-nostudyaccess.component.css'],
})
export class ErrorNoStudyAccessComponent {}
